/** User-facing copy for stream stats content */
export const STREAM_STATS_CONTENT_MESSAGES = {
  backToStreamers: "Back to Streamers",
  previousMonth: "Previous month",
  nextMonth: "Next month",
  streamStatsTitle: "Stream Stats",
  progressGraphTitle: "Airtime & Share of Airtime Tracker",
} as const
